import { ReactElement } from 'react';
import {
  Button,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  CircularProgress,
  Chip,
  Paper,
  Typography
} from '@material-ui/core';
import ModalContainer from 'components/molecules/ModalContainer';
import useStyles from './PurchaseOrder.styles';
import { IOrders, IPurchaseDetail, IPurchaseProducts } from 'interfaces/purchaseOrders.interface';

interface Props {
  purchaseDetail: IPurchaseDetail;
  openModal: boolean;
  closeModal: () => void;
}

export default function PurchaseOrderModal({ purchaseDetail, openModal, closeModal }: Props): ReactElement {
  const classes = useStyles();

  return (
    <ModalContainer
      open={openModal}
      onClose={closeModal}
      title={`Número de Orden - ${purchaseDetail.ocNumber}`}
      maxWidth="lg"
    >
      {purchaseDetail.orders.length > 0 ? (
        <div>
          {purchaseDetail.orders.map((orderDetail: IOrders) => {
            return (
              <Grid container justify="center" key={orderDetail.orderNumber}>
                <Grid container justify="center" className={classes.title}>
                  <Typography variant="h6" key={orderDetail.orderNumber}>
                    Pedido #{orderDetail.orderNumber}
                  </Typography>
                </Grid>
                <Paper variant="outlined" className={classes.tableContainer}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell className={classes.tableCabeceras} align="right" style={{ width: '10%' }}>
                          SKU
                        </TableCell>
                        <TableCell className={classes.tableCabeceras} align="right" style={{ width: '70%' }}>
                          Producto
                        </TableCell>
                        <TableCell className={classes.tableCabeceras} align="right" style={{ width: '20%' }}>
                          Cantidad
                        </TableCell>
                        <TableCell className={classes.tableCabeceras} align="right" style={{ width: '20%' }}>
                          # Guía
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {orderDetail.products.map((product: IPurchaseProducts) => {
                        return (
                          <TableRow key={product.id}>
                            <TableCell>{product.sku}</TableCell>
                            <TableCell>{product.name}</TableCell>
                            <TableCell>{product.quantity}</TableCell>
                            <TableCell>
                              {product.trackingNumber ? (
                                <Chip
                                  variant="outlined"
                                  clickable
                                  size="small"
                                  color="primary"
                                  label={`${product.trackingNumber}`}
                                  onClick={() => {
                                    window.open(`${product.trackingUrl}`);
                                  }}
                                />
                              ) : (
                                <Chip variant="outlined" size="small" color="primary" label="No enviado" clickable />
                              )}
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </Paper>
              </Grid>
            );
          })}
          <Grid container justify="center">
            <Button
              variant="contained"
              color="primary"
              style={{ marginTop: 20, marginLeft: 20 }}
              onClick={() => closeModal()}
            >
              Cerrar
            </Button>
          </Grid>
        </div>
      ) : (
        <Grid container direction="column" justify="center" alignItems="center">
          <CircularProgress color="primary" />
          <Typography variant="h6">Cargando...</Typography>
        </Grid>
      )}
    </ModalContainer>
  );
}
